import { HttpErrorResponse } from '@angular/common/http';

/** Extracts a user-readable message from an HTTP error; tries `{ "error": "..." }` (Gin standard) first. */
export function extractApiError(err: unknown): string {
  if (!(err instanceof HttpErrorResponse)) {
    return String(err) || 'Unknown error';
  }

  const body = err.error;

  // Go/Gin standard: { "error": "some message" }
  if (body && typeof body === 'object') {
    if (typeof body['error'] === 'string' && body['error']) {
      return `[${err.status}] ${body['error']}`;
    }
    if (typeof body['message'] === 'string' && body['message']) {
      return `[${err.status}] ${body['message']}`;
    }
    // Do not dump the full body — it may contain internal server details.
    return `[${err.status}] Unexpected error`;
  }

  // Plain string body — only expose if it looks like a safe user-facing message
  // (no JSON structures, stack traces, or internal details).
  if (typeof body === 'string' && body && body.length <= 200 && !body.includes('{')) {
    return `[${err.status}] ${body}`;
  }

  return `[${err.status}] No error message from backend`;
}
